export const SUBSCRIPTION_GROUPS_KEY = "/engagement/:app_group_id/whats_app_subscription_groups" as const;
